/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./User.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import Context from "lib/context";
import ServicesContext from "services/ServicesContext";

import { UserProps, UserState } from "./User.types";

import Dialog from "components/ThreeKey/Dialogs/Dialog";
import Input from "components/ThreeKey/Input/Input";
import Select, { SelectItem } from "components/ThreeKey/Select";
import InputDropDown from "components/ThreeKey/InputDropDown";


class User extends React.Component<UserProps, UserState> {

   static contextType = Context;
   public context!: ServicesContext;

   private groupsRef: React.RefObject<Select> = React.createRef<Select>()

   constructor(props: UserProps) {

      super(props);

      this.state = {
         username: this.props.data.user.username,
         role: this.props.data.user.role
      }
   }

   public render(): React.ReactNode {

      const saveDisabled = false;

      const roles: string[] = [ "admin", "user" ];

      const groups: SelectItem[] = [ ...this.props.data.groups ]
         .sort(
            (a, b) => {
               if (a.name < b.name) return -1;
               if (a.name > b.name) return 1;
               return 0;
            }
         )
         .map(
            g => {

               return {
                  id: g.id,
                  value: `${g.name}~${g.description}`,
                  checked: this.props.data.user.groups.find(ug => ug === g.id) !== undefined
               }
            }
         )

      return (

         <Dialog closeOnEscape={true} closeOnOverlayMouseDown={true} onClose={this.onCancel}>

            <div className="group-dialog">

               <div className="label">
                  User details
               </div>

               <div className="columns">

                  <div className="column">

                     <div className="item">
                        <label htmlFor="username">Username (email address):</label><br />
                        <Input id="username" value={this.state.username} onChange={this.onUsernameChange} autoComplete="off" disabled={this.state.username === this.context.api.auth?.getAuthenticatedUser() } />
                     </div>

                     <div className="item">

                        <label htmlFor="role">Company role:</label><br />

                        <InputDropDown
                           readOnly={true}
                           items={roles}
                           value={this.state.role === "company_admin" ? "admin" : "user"}
                           onChange={this.onRoleChange}
                           dropDownOnKeyDown={true}
                           dropDownOnFocus={true}
                           disabled={this.state.username === this.context.api.auth?.getAuthenticatedUser() || true }
                        />

                     </div>

                  </div>

                  <div className="column">

                     <div>Group membership:</div>

                     <Select ref={this.groupsRef} componentName="groups" hasCheckBoxes={true} items={groups} disabled={true} />

                  </div>

               </div>

               <div className="buttons">
                  <button data-type="ok" disabled={saveDisabled} onClick={this.onSave}>Save</button>
                  &nbsp;&nbsp;&nbsp;
                  <button data-type="cancel" onClick={this.onCancel}>Canel</button>
               </div>

            </div>

         </Dialog>

      )

   }

   private onSave = () => {

      if (!this.props.onSave || !this.groupsRef.current) return;

      const groups = this.groupsRef.current.state.items
         .filter(i => i.checked)
         .map(i => i.id) as string[];

      this.props.onSave({
         _seq_no: this.props.data.user._seq_no,
         _primary_term: this.props.data.user._primary_term,
         companyId: this.props.data.user.companyId,
         id: this.props.data.user.id,
         username: this.state.username,
         role: this.state.role,
         groups,
         lastInvitation: 0
      })

   }

   private onCancel = () => {
      this.props.onClose();
   }

   private onUsernameChange = (value: string | number) => {
      this.setState({ username: value.toString() });
   }

   private onRoleChange = (value: string) => {
      this.setState({ role: value === "admin" ? "company_admin" : "company_user" });
   }

}


const mapStateToProps = (state: {
   sliceName: any, // redux state interface
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            // slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(User);